import { Button, Grid, Typography } from "@mui/material"
import { Box } from "@mui/material"
import { FormBuilder } from "@components/FormBuilder"
import { useMemo } from "react"
import { getContractFormFields } from "./const"
import { FormProvider, useForm } from "react-hook-form"
import { useGetOrganisationsQuery } from "@store/services"
import { useCreateContractMutation } from "@store/services/contractService"
import Notification from "@components/Notification"
import { useNavigate } from "react-router"

export const AddContract = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const formMethods = useForm<any>({
    defaultValues: {
      organisation_key: "",
      division_key: "",
      salesforce_id: "",
      salesforce_contact: "",
      salesforce_contact_email: "",
      active: true,
      description: "",
      sftp: "",
      start_date: new Date(),
      end_date: new Date(),
      product_families: [],
      webhook_url: "",
    },
  })
  const watchedOrganisationKey = formMethods.watch("organisation_key")
  const navigate = useNavigate()
  const { data: organisationsData } = useGetOrganisationsQuery({})
  const [createContract, { data: createdContract }] = useCreateContractMutation()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  const onSubmit = (data: any) => createContract(data)

  const organisationsListWithDivisions = useMemo(() => {
    const orgs: {
      [key: string]: Set<string>
    } = {}

    organisationsData?.items.forEach((org) => {
      if (!orgs[org.key]) {
        orgs[org.key] = new Set()
      }

      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      org?.divisions?.forEach((division) => orgs[org.key].add(division.key))
    })

    return orgs
  }, [organisationsData])

  const contractFormFields = useMemo(
    () =>
      getContractFormFields({
        organisationOptions: Object.keys(organisationsListWithDivisions).map((key) => ({
          id: key,
          value: key,
        })),
        divisionOptions: Array.from(
          organisationsListWithDivisions[watchedOrganisationKey] || [],
        ).map((key) => ({ id: key, value: key })),
      }),
    [organisationsListWithDivisions, watchedOrganisationKey],
  )

  const onCancelClick = () => navigate("/Administration/Contracts")

  return (
    <Box sx={{ mt: 4, px: 1.5 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Add Contract
      </Typography>
      <FormProvider {...formMethods}>
        <form autoComplete={"off"} onSubmit={formMethods.handleSubmit(onSubmit)}>
          <Grid container={true} spacing={2} alignItems="center" sx={{ mb: 4 }}>
            {Object.keys(contractFormFields).map((fieldName) => (
              <Grid item xs={6} key={fieldName}>
                <FormBuilder
                  field={fieldName}
                  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
                  component={contractFormFields[fieldName]}
                  helperText={formMethods.formState.errors[fieldName]?.message as string}
                  inputWidth="100%"
                  dropdownWidth="100%"
                />
              </Grid>
            ))}
          </Grid>
          <Grid item={true} xs={12}>
            <Button variant="contained" type="submit">
              Add
            </Button>
            <Button
              sx={{ ml: 1 }}
              variant="contained"
              color={"error"}
              type="button"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </Grid>
        </form>
      </FormProvider>
      <Notification
        message={createdContract ? "Contract created" : ""}
        onClose={() => navigate("/Administration/Contracts")}
      />
    </Box>
  )
}
